<template>

    <div class="siteNewsletterSingle">

        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

                <div class="centered rteInfo">

                    <span class="icon is-small">
                        <i class="icon-ak-info"></i>
                    </span>
                    <lang labelKey="NEWSLETTER-ELEMENT-RTE-INFO"></lang>
                    <!-- Info blabla Konzept sagt dazu: "Angaben zu max. sinnvollen Textlängen und den idealen Bildformaten" -->

                </div>

                <div class="hrLine"></div>

                <!-- title intern -->
                <div class="centered is-clearfix">

                    <form-input inputType="text" label="NEWSLETTER_PHARMACY-TITLE_INTERN" v-model="siteNewsletter.title" placeholder="" :isHorizontal="false" :isReadOnly="isReadOnly"></form-input>

                    <div class="control">
                        <div class="control-label">
                            <label-name labelKey="NEWSLETTER_PHARMACY-SCHEDULE_DATE"></label-name>
                        </div>

                        <div class="control">
                            <datepicker placeholder="Datum wählen" :options="datePickerOptions" v-model="siteNewsletter.newsletter.scheduleDate" :class="{ 'is-disabled': siteNewsletter.newsletter.parent != null || isReadOnly }"></datepicker>
                        </div>
                    </div>

                </div>

                <div class="hrLine"></div>

                <div class="centered is-clearfix">

                    <form-input inputType="text" label="NEWSLETTER_PHARMACY-SUBJECT" v-model="siteNewsletter.subject" placeholder="Betreff ..." :isHorizontal="false" :isReadOnly="isReadOnly"></form-input>

                    <div class="control">
                        <div class="control-label">
                            <label><lang labelKey="NEWSLETTER_PHARMACY-INTRO_TEXT"></lang></label>
                        </div>
                        <div class="froalaRTE froalaPlain">
                            <froala id="froalaHeader" ref="froalaHeader" :tag="'textarea'" :config="froalaConfig" v-model="siteNewsletter.introText"></froala>
                        </div>
                    </div>

                </div>

                <div class="hrLine"></div>

                <!-- BANNERS -->
                <div class="centered banners" v-if="!isLoadingBanners">

                    <div v-for="banner in banners" v-lazy:background-image="getAsset(banner)" :class="['banner lazy-img-fadein', {'is-active': bannerIsActive(banner)}]" :key="banner.id">
                        <div class="checkbox">
                            <p-check class="p-default p-smooth p-bigger p-pulse" :value="banner.id" :checked="bannerIsActive(banner)" color="primary" @change="activateBanner(banner)"></p-check>
                        </div>

                    </div>

                </div>

                <div class="hrLine"></div>

                <div class="centered">

                    <div class="newsletterArticles">

                        <draggable
                            :list="siteNewsletter.elements"
                            :options="{
                                animation: 350,
                                handle: '.dragHandler',
                                draggable: '.list-complete-item',
                                ghostClass: 'ghost-OUT'
                            }"
                            @start="isDragging=true"
                            @end="onDragComplete(siteNewsletter.elements)">

                            <!-- <transition-group type="transition" name="flip-list"> -->

                            <div v-for="(element, elementIndex) in siteNewsletter.elements" class="columns is-multiline newsletterArticle list-complete-item" :key="element.catalogPageElement">


                                <!-- CATALOG PAGE ELEMENTS -->
                                <template v-if="element.catalogPageElement != null">

                                    <div class="column is-narrow">
                                        <!-- <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + element.catalogPageElement.image"></div> -->
                                        <img class="lazy" v-lazy="$config.assets + element.catalogPageElement.image" />
                                    </div>

                                    <div class="column">

                                        <div class="preview">
                                            <span class="headline">{{ element.catalogPageElement.headline }}</span>
                                            <div v-html="element.catalogPageElement.subheadline"></div>
                                            <div v-html="getExcerpt(element.catalogPageElement, 500)"></div>
                                        </div>

                                    </div>

                                    <div class="column is-narrow actions">

                                        <span class="icon is-small dragHandler has-cursor-move">
                                            <i class="icon-ak-move"></i>
                                        </span>

                                        <pop-confirm :class="['icon is-small has-pointer delArticle', {'is-disabled': isReadOnly }]" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { newsletterElementRemove(elementIndex) }">
                                            <i class="fa icon-ak-entfernen"></i>
                                        </pop-confirm>
                                    </div>


                                    <div class="column is-12 appendedProducts">

                                        <div class="title">
                                            <lang labelKey='NEWSLETTER-ELEMENT-APPENDED_PRODUCTS'></lang>
                                        </div>

                                        <div :class="['appendedProductsWrapper', { 'is-disabled': isReadOnly }]">

                                            <template v-for="(pSlot, pSlotIndex) in element.productSlots">

                                                <template v-if="pSlot">

                                                  <div class="productCol" :key="pSlot.product">

                                                      <div class="product filled">

                                                            <div class="content">

                                                              <template v-if="pSlot.product != null">

                                                                  <template v-if="pSlot.showPrice && pSlot.product.offer && pSlot.product.offer != null">

                                                                    <div class="flash">-{{ getProductFlashPrice(pSlot.product)}}</div>
                                                                  </template>

                                                                    <img :src="$config.assets + pSlot.product.image" class="productImage" />
                                                                    <div style="display: flex; flex-direction: column">
                                                                      <div class="productTitle">
                                                                          {{ pSlot.product.name }}
                                                                      </div>
                                                                      <div class="productPrice" v-html="getProductPrice(pSlot.product)"  v-if="pSlot.showPrice && pSlot.product.price">

                                                                      </div>
                                                                    </div>
                                                                </template>

                                                            </div>

                                                            <div class="showPriceSwitcher">
                                                                <p-check :key="pSlot.showPrice" name="check" color="primary" class="p-switch p-slim" v-model="pSlot.showPrice" @click.prevent.native="toggleShowPrice(elementIndex, pSlotIndex)">zeige Preis</p-check>
                                                                <!-- <p-check name="check" color="primary" :value="pSlot.showPrice" v-model="pSlot.showPrice" class="p-default p-curve p-smooth"></p-check> -->
                                                            </div>

                                                            <span class="deleteProduct has-pointer" @click="productDelete(element, pSlotIndex)">
                                                                <span class="icon"><i class="icon-ak-entfernen"></i></span>
                                                            </span>

                                                        </div>

                                                        <div v-if="pSlot.voucherImageUrl && pSlot.voucherImageUrl != null" class="productVoucher">

                                                            <img :src="pSlot.voucherImageUrl" class="voucherImage" />

                                                        </div>

                                                    </div>

                                                </template>

                                                <template v-else>

                                                    <div class="productCol">
                                                        <div class="product has-pointer" @click="productAdd(elementIndex, pSlotIndex)">
                                                            <span class="icon"><i class="icon-ak-hinzufuegen"></i></span>
                                                        </div>
                                                    </div>

                                                </template>

                                            </template>


                                        </div>

                                    </div>

                                </template>


                                <!-- CONTENT ELEMENTS -->
                                <template v-else>


                                    <div class="column">

                                        <div :class="['control froalaRTE froalaPlain']">
                                            <froala :id="'froala-'+element.id" :ref="'froala-'+element.id" :tag="'textarea'" :config="froalaConfig" v-model="element.content"></froala>
                                        </div>

                                    </div>

                                    <div class="column is-narrow actions">

                                        <span class="icon is-small dragHandler has-cursor-move">
                                            <i class="icon-ak-move"></i>
                                        </span>

                                        <pop-confirm :class="['icon is-small has-pointer delArticle', {'is-disabled': isReadOnly }]" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { newsletterElementRemove(elementIndex) }">
                                            <i class="fa icon-ak-entfernen"></i>
                                        </pop-confirm>
                                    </div>


                                    <div class="column is-12 appendedProducts" v-if="activeUser.site.hasApoPoint">

                                        <div class="title">
                                            <lang labelKey='NEWSLETTER-ELEMENT-APPENDED_PRODUCTS'></lang>
                                        </div>

                                        <div :class="['appendedProductsWrapper', { 'is-disabled': isReadOnly }]">

                                            <template v-for="(pSlot, pSlotIndex) in element.productSlots">

                                                <template v-if="pSlot">

                                                    <div class="productCol" :key="pSlot.product">

                                                        <div class="product filled">

                                                            <div class="content">

                                                              <template v-if="pSlot.product != null">

                                                                  <template v-if="pSlot.showPrice && pSlot.product.offer && pSlot.product.offer != null">
                                                                    <div class="flash">-{{ getProductFlashPrice(pSlot.product)}}</div>
                                                                  </template>

                                                                    <img :src="$config.assets + pSlot.product.image" class="productImage" />
                                                                    <div style="display: flex; flex-direction: column">
                                                                      <div class="productTitle">
                                                                          {{ pSlot.product.name }}
                                                                      </div>
                                                                      <div class="productPrice" v-html="getProductPrice(pSlot.product)"  v-if="pSlot.showPrice && pSlot.product.price">

                                                                      </div>
                                                                    </div>
                                                                </template>

                                                            </div>

                                                            <div class="showPriceSwitcher">
                                                                <p-check :key="pSlot.showPrice" name="check" color="primary" class="p-switch p-slim" v-model="pSlot.showPrice" @click.prevent.native="toggleShowPrice(elementIndex, pSlotIndex)">zeige Preis</p-check>
                                                                <!-- <p-check name="check" color="primary" :value="pSlot.showPrice" v-model="pSlot.showPrice" class="p-default p-curve p-smooth"></p-check> -->
                                                            </div>

                                                            <span class="deleteProduct has-pointer" @click="productDelete(element, pSlotIndex)">
                                                                <span class="icon"><i class="icon-ak-entfernen"></i></span>
                                                            </span>

                                                        </div>

                                                        <div v-if="pSlot.voucherImageUrl && pSlot.voucherImageUrl != null" class="productVoucher">

                                                            <img :src="pSlot.voucherImageUrl" class="voucherImage" />

                                                        </div>

                                                    </div>

                                                </template>

                                                <template v-else>

                                                    <div class="productCol">
                                                        <div class="product has-pointer" @click="productAdd(elementIndex, pSlotIndex, false)">
                                                            <span class="icon"><i class="icon-ak-hinzufuegen"></i></span>
                                                        </div>

                                                    </div>

                                                </template>

                                            </template>


                                        </div>

                                    </div>

                                </template>

                            </div>
                            <!-- </transition-group> -->

                        </draggable>


                        <div class="newsletterActions">

                            <div :class="['button has-pointer', { 'is-disabled': isReadOnly }]" @click="openNewsletterArticles" v-if="newsletterPageElements.length < maxArticles">
                                <span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span> Apothekenkatalog-Beitrag
                            </div>

                            <div :class="['button has-pointer', { 'is-disabled': isReadOnly }]" @click="addTextElement">
                                <span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span> eigener Beitrag
                            </div>

                        </div>

                    </div>
                </div>

                <div class="hrLine"></div>

                <div class="centered">

                    <div class="froalaRTE froalaPlain control">
                        <div class="control-label">
                            <label><lang labelKey="NEWSLETTER_PHARMACY-ADDITIONAL_TEXT"></lang></label>
                        </div>
                        <froala id="froalaFooter" ref="froalaFooter" :tag="'textarea'" :config="froalaConfig" v-model="siteNewsletter.additionalText"></froala>
                    </div>

                    <form-input inputType="text" label="NEWSLETTER_PHARMACY-FOOTER" v-model="siteNewsletter.footer" placeholder="Kontaktinformationen Ihrer Apotheke und Abmeldeoption werden automatisch ergänzt" :isReadOnly="isReadOnly" :isHorizontal="false"></form-input>

                </div>


                <div class="has-text-centered sectionButtons">
                    <custom-button type="blue" name="NEWSLETTER-PHARMACY-BTN-NEWSLETTER_SAVE" icon="icon-ak-speichern" @click.native="newsletterSave" :class="{ 'is-disabled': isReadOnly, 'is-loading': isSaving }"></custom-button>
                    <custom-button type="blue" name="NEWSLETTER-PHARMACY-BTN-NEWSLETTER_SEND" icon="icon-ak-send" @click.native="newsletterSend" :class="{ 'is-loading': isSending }"></custom-button>
                    <custom-button type="blue" name="NEWSLETTER-PHARMACY-BTN-NEWSLETTER_SEND_TEST" icon="icon-ak-send" @click.native="newsletterSendTest" :class="{ 'is-disabled': isReadOnly, 'is-loading': isSendingTest }"></custom-button>
                    <export-button v-if="newsletter.siteNewsletter && newsletter.siteNewsletter.id" export="newsletter" modalTitle="NEWSLETTER-MODAL_HEADER-EXPORT_NEWSLETTER" btnTitle="NEWSLETTER-BTN-EXPORT-NEWSLETTER" :exportId="siteNewsletter.id"></export-button>
                </div>

                <!-- <lang labelKey="NEWSLETTER-MODAL_HEADER-EXPORT_NEWSLETTER"></lang> -->


            <!-- MODAL -->
            <modal
                :width="modal.width"
                :title="modal.title"
                transition="fadeDown"
                cancel-text="Abbrechen"
                :show-ok="false"
                :backdrop-closable="false"
                :is-show="showModal"
                :class="modal.class"
                @close="closeModal">

                    <template v-if="modal.isLoading">

                        <loading-indicator></loading-indicator>

                    </template>

                    <template v-else>

                        <!-- SELECT ARTICLES -->
                        <template v-if="modal.type == 'newsletterArticles'">

                            <v-client-table ref="tblNewsletterArticles" name="tblNewsletterArticles" :data="articles.data" :columns="articles.columns" :options="articles.options" class="tblNewsletterArticles noFirstColumn">

                                <!-- before table: FILTER OPTIONS -->
                                <template slot="beforeTable">

                                    <!-- search -->
            	                    <div class="control has-icon search is-pulled-left">
            	                        <input class="input" type="text" v-model.trim="articleSearchString" placeholder="Suchbegriff">
            	                        <i class="fa fa-search" aria-hidden="true"></i>
            	                    </div>

                                </template>

                                <!-- checkbox -->
                                <template slot="select" slot-scope="props">
                                    <div class="checkboxWrapper">
                                        <p-check name="check" color="primary" :value="props.row.id" v-model="markedRows" class="p-default p-curve p-smooth"></p-check>
                                    </div>
                                </template>

                                <!-- image -->
                                <template slot="asset" slot-scope="props">
                                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets +  props.row.image" :key="props.row.id"></div>
                                </template>

                                <!-- name -->
                                <template slot="name" slot-scope="props">
                                    {{ props.row.headline }}
                                </template>

                            </v-client-table>

                            <div slot="footer">
                                <span class="button" @click="closeModal">schließen</span>
                                <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="newsletterAppendArticles">übernehmen</span>
                            </div>

                        </template>


                        <!-- ADD PRODUCT -->
                        <template v-else-if="modal.type == 'articleProducts'">

                            <template v-if="showDefaultProducts && defaultProducts != null && defaultProducts.length > 0">

                                <lang labelKey="NEWSLETTER-PRODUCT_SELECT" class="productSelectTitle"></lang>
                                <div class="defaultProducts">

                                    <div v-for="product in defaultProducts" :class="['lazy-img-fadein defaultProduct', { 'is-selected': productSelected==product }]"  v-lazy:background-image="$config.assets + product.image" :key="product.id" @click="productSelected=product">

                                    </div>

                                </div>

                            </template>


                            <template v-if="activeUser.site.hasApoPoint">

                                <lang labelKey="NEWSLETTER-PRODUCT_SEARCH" class="productSelectTitle"></lang>

                                <div>

                                    <!-- :placeholder="$t('SELECT_BOX-PRODUCTS-PLEASE_SELECT')" -->
                                    <multiselect
                                        v-model="productSelected"
                                        :options="asyncFetchedProducts"
                                        label="name"
                                        deselect-label="Klick um abzuwählen"
                                        selectLabel="Klick um auszuwählen"
                                        selectedLabel="ausgewählt"
                                        placeholder="Bitte Produktname oder PZN eingeben..."
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :hide-selected="false"
                                        :preserve-search="true"
                                        @search-change="asyncGetProducts"
                                        :loading="isAsyncFetchingData"
                                        openDirection="bottom"
                                        track-by="id"
                                        class="singleSelect">

                                            <template slot="singleLabel" slot-scope="props">
                                                <div class="option__image">

                                                </div>
                                                <span class="option__desc"><span class="option__title">{{ props.option.name }}</span></span>
                                            </template>

                                            <template slot="option" slot-scope="props">
                                                <div class="option__image">

                                                </div>
                                                <span class="option__desc"><span class="option__title">{{ props.option.name }}</span></span>
                                            </template>

                                            <span slot="noOptions">bitte Suchbegriff eingeben</span>
                                            <span slot="noResult">Für diesen Suchbegriff konnte kein Product gefunden werden.</span>

                                    </multiselect>


                                </div>

                            </template>

                            <div slot="footer">
                                <span class="button" @click="closeModal">schließen</span>
                                <span :class="['button is-success', { 'is-loading': modal.isSaving || modal.isLoading }]" @click="articleAppendProduct">übernehmen</span>
                            </div>

                        </template>

                        <!-- SEND NEWSLETTER -->
                        <template v-else-if="modal.type == 'newsletterSend'">

                            <p>Wollen Sie den Newsletter an alle eMail-Adressen aus der Empfänger-Liste versenden?</p>

                            <div slot="footer">
                                <span class="button" @click="closeModal">abbrechen</span>
                                <span class="button is-success" @click="newsletterSendOk">senden</span>
                            </div>

                        </template>

                        <!-- SEND TEST NEWSLETTER -->
                        <template v-else-if="modal.type == 'newsletterSendTest'">

                            <template v-if="progressStatus == null">

                                <form-input v-model="testRecipient" placeholder="Email des Empfängers"></form-input>

                                <div slot="footer">
                                    <span class="button" @click="closeModal">abbrechen</span>
                                    <span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="newsletterSendTestOk">senden</span>
                                </div>
                            </template>

                            <template v-else>

                                <template v-if="progressStatus.status != 'Finished'">

                                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                                    <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                                </template>

                                <template v-else>

                                    <div class="has-text-centered">Test Email erfolgreich versandt!</div>

                                </template>


                            </template>

                        </template>


                        <!-- PROGRESS -->
                        <template v-else-if="modal.type == 'progress'">


                            <template v-if="progressStatus == null">

                                <loading-indicator-small></loading-indicator-small>

                            </template>

                            <template v-else>

                                <template v-if="progressStatus.status != 'Finished'">

                                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                                    <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                                </template>

                                <template v-else>

                                    <div class="has-text-centered">Empfänger erfolgreich hochgeladen</div>

                                </template>

                            </template>


                        </template>

                        <template v-else-if="modal.type == 'error'">

                            {{ modal.msg }}

                        </template>

                    </template>

            </modal>

        </template>

    </div>

</template>



<script>
import Vue from 'vue';

// import inputCounter from '../utils/inputCounter';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
require('pretty-checkbox/src/pretty-checkbox.scss')
Vue.use(PrettyCheckbox);

import { de } from 'flatpickr/dist/l10n/de';

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

// require('froala-editor/js/froala_editor.min.js')
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)


import draggable from 'vuedraggable';
import exportButton from '../utils/exportButton';

export default {

    components: {
        draggable,
        VueFroala,
        exportButton
    },

    props: {

        newsletter: {
            type: Object,
            default: null
        },

        maxArticles: {
            type: Number,
            default: 4
        }

    },

    data() {

        var self = this;

        return {

            siteNewsletter: null,

            progressStatus: null,

            isLoading: false,
            isSaving: false,
            isDragging: false,
            isSending: false,
            isSendingTest: false,

            testRecipient: null,
            recipients: [],
            refreshIntervalId: null,

            defaultProducts: [],
            asyncFetchedProducts: [],

            currentElement: null,
            currentElementIndex: null,
            currentProductSlot: null,
            productSelected: null,

            isAsyncFetchingData: false,

            showModal: false,

            modal: {
                isLoading: false,
                isSaving: false,
                type: 'articles',
                title: '',
                width: '880',
                class: '',
                msg: ''
            },

            isLoadingBanners: false,
            banners: [],
            newsletterBanners: [],

            showDefaultProducts: false,
            articleSearchString: '',

            markedRows: [],

            datePickerOptions: {
              enableTime: false,
              altInput: true,
              altFormat: 'd.m.Y',
              locale: de,
              clickOpens: true,
              weekNumbers: true,
            },

            // ARTICLES
            articles: {

                data: [],
                columns: ['select', 'asset', 'name'],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings
                    headings: {

                        select(h) {
                            return "";
                        },
                        asset(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-ASSET"></lang>
                        },
                        name(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-NAME"></lang>
                        },

                    },

                    sortable: ['name'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [
                        {
                        name: 'search',
    						callback(row, string) {

    							if(string == null || string == "") {
    								return true;
    							}

    							string = string.toLowerCase();
    							return row.headline.toLowerCase().indexOf(string) > -1 || row.subheadline.toLowerCase().indexOf(string) > -1;

    						}
                        }

                    ],

                }
            },

            froalaConfig: {
                heightMin: 250,
		            heightMax: 750,
                key: '',
		            // 'insertImage',
                // toolbarButtons: ['bold', 'italic', 'underline', 'h1', '|', 'insertLink', '|', 'subscript', 'superscript', '|', 'align', '|', 'customImageButton', '|', 'undo', 'redo'],
                toolbarButtons: ['bold', 'italic', 'underline', 'h2', 'fontSize', 'color', '|', 'insertLink', 'insertImage', '|', 'subscript', 'superscript', '|', 'align', '|', 'undo', 'redo'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
		            wordPasteModal: false,
                pastePlain: true,
                initOnClick: false,
                quickInsertTags: [],
                language: 'de',
        				charCounterCount: true,
        				// charCounterMax: 140,
                imageUpload: true,
                // imageDefaultAlign: 'left',
                // imageDefaultDisplay: 'inline-block',
                // Set max image size to 5MB.
                imageMaxSize: 5 * 1024 * 1024,
                // Allow to upload PNG and JPG.
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                // imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],
                imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageAlt', 'imageSize'],

                // imageUploadURL: self.$config.api + 'fileProcessing/upload?preset=article',
                imageUploadRemoteUrls: false,
                imagePaste: false,

                // https://www.froala.com/wysiwyg-editor/docs/concepts/image/upload
                // https://medium.com/@junaidtunde1/angular-2-with-froala-text-editor-image-upload-to-remote-server-732ef2793356
                events: {

                    'froalaEditor.initialized' : function(e, editor) {
                        if(self.isReadOnly) {
                            editor.edit.off();
                        }
                    },

                    'froalaEditor.image.beforeUpload': function(e, editor, images) {

                        // Before image is uploaded
                        const data = new FormData();
                        data.append('file', images[0]);

                        self.axios.post(self.$config.api + 'fileProcessing/upload?preset=site', data, {

                            }).then(res => {

                                let link = self.$config.assets + res.data.dir + '/' + res.data.fileName;
                                editor.image.insert(link, null, null, editor.image.get());

                            }).catch(err => {
                                console.log(err);
                            });

                        return false;

                    }
                }

            },

        }

    },


    created() {

        this.froalaConfig.key = this.$config.froalaKey;
        this.initNewsletter();

    },

    mounted() {

    },

    computed: {

        isReadOnly() {

            if(this.siteNewsletter.newsletter == null) {
                return false;
            } else {
                return this.siteNewsletter.newsletter.status == '157';
            }

        },

        newsletterPageElements() {

            if(!this.siteNewsletter.elements) {
                return [];
            }

            return this.siteNewsletter.elements.filter(el => el.catalogPageElement != null);

        },

        newsletterStatus() {

            return this.$store.getters.getTermsByTaxonomy('NEWSLETTER_STATUS');

        },

        siteId() {

            return this.activeUser.site.id;

        },

    },

    watch: {

        articleSearchString(newVal, oldVal) {

            if(newVal == oldVal) {
                return;
            }
            var self = this;

            setTimeout(function() {
                Event.$emit('vue-tables.tblNewsletterArticles.filter::search', newVal );
            }, 50);

        },

        markedRows(newVal, oldVal) {

            if(this.markedRows.length > this.maxArticles) {
                this.$notify.open( { content: 'Sie können nur maximal '+this.maxArticles+' Artikel auswählen', type: 'warning' })
            }

        },

        newsletter(newVal, oldVal) {

            this.initNewsletter();

        }

    },

    methods: {
      /*
      AAtoggleShowPrice(pSlot) {
        pSlot.showPrice != pSlot.showPrice;
        this.$forceUpdate();
      },
      */

      toggleShowPrice(elementIndex, pSlotIndex) {
        // console.log(this.siteNewsletter.elements[elementIndex].productSlots[pSlotIndex].showPrice);
        this.$set(this.siteNewsletter.elements[elementIndex].productSlots[pSlotIndex], 'showPrice', !this.siteNewsletter.elements[elementIndex].productSlots[pSlotIndex].showPrice);
        this.$forceUpdate();
      },

      getProductFlashPrice(product) {
        // console.log("getting product flash price for ", product);
        if(product.offer.displayType == 'p') {
          return Math.round(100 - (product.offer.price/product.price * 100)) / 100 + '%'
        } else {
          return (Math.round((product.price - product.offer.price) * 100) /100).toString().replace('.', ',') + '€';
        }
      },

      getProductPrice(product) {

        return (product.offer != null && product.offer.price)
          ? '<s>'+(product.price).toString().replace('.', ',')+'€</s> ' + (product.offer.price).toString().replace('.', ',') + '€'
          : (product.price).toString().replace('.', ',') + '€';

      },

      getAsset(asset, thumb=false) {

  			if(asset == null) {
  				return "";
  			}

  			return this.$config.assets + asset.path + '/' + (thumb == true ? 'thumb/' : '' ) + asset.filename;

  		},

        fetchBanners() {

			var self = this;

			return new Promise(function(resolve, reject) {

				self.axios.get(self.$config.api + 'asset?filters[path]=newsletterBanner')
					.then(res => {
						resolve(res.data.asset);
					});

			})

		},

    bannerIsActive(banner) {

      return this.siteNewsletter.newsletter.banners && this.siteNewsletter.newsletter.banners.length > 0 && this.siteNewsletter.newsletter.banners.findIndex(b => b.asset == banner.id) > -1;
      // return this.newsletterBanners.length > 0 && this.newsletterBanners.findIndex(b => b.asset == banner.id) > -1;

	 },

 		activateBanner(banner) {

      let foundIndex = -1;

      if(!this.siteNewsletter.newsletter.banners) {
          this.$set(this.siteNewsletter.newsletter, "banners", []);
          // this.siteNewsletter.newsletter.banners = [];
      } else {
          foundIndex = this.siteNewsletter.newsletter.banners.findIndex(b => b.asset == banner.id);
      }

 			// banner shall be added to the lookup table
 			if(foundIndex == -1) {

        this.siteNewsletter.newsletter.banners.push({
          asset: banner.id,
          newsletter: this.newsletter.id
        })

        } else {

          this.siteNewsletter.newsletter.banners.splice(foundIndex, 1);

        }

 		   },

        goBack() {

          this.$emit('select', null);

        },

        fetchRecipients() {

            return this.axios.get(this.$config.api + 'newsletter/subscribers?site='+this.siteId)
                .then(res => {
                    return res;
                })

        },

        initNewsletter() {

            this.isLoading = true;
            this.isLoadingBanners = true;

            this.fetchBanners().then(res => {

                this.banners = res;
                this.isLoadingBanners = false;


                if(this.newsletter == 'new') {

                    this.siteNewsletter = {
                        site: this.siteId,
                        title: '',
                        introText: null,
                        salutation: null,
                        additionalText: null,
                        subject: null,
                        elements: [],
                        newsletter: {
                            name: '',
                            channel: 12,
                            site: this.siteId,
                            status: this.newsletterStatus.DRAFT,
                            scheduleDate: null,
                        }
                    }

                    this.isLoading = false;

                } else {

                    this.fetchData();

                }


            // Check if button is active.
            var isActive = function (cmd) {

        			var blocks = this.selection.blocks();

        			if (blocks.length) {
        				var blk = blocks[0];
        				var tag = 'N';
        				var default_tag = this.html.defaultTag();
        				if (blk.tagName.toLowerCase() != default_tag && blk != this.el) {
        					tag = blk.tagName;
        				}
        			}

        			if (['LI', 'TD', 'TH'].indexOf(tag) >= 0) {
        				tag = 'N';
        			}

        			return tag.toLowerCase() == cmd;
        		}

                $.FroalaEditor.DefineIcon('h2', { NAME: 'H', template: 'text'});
                $.FroalaEditor.RegisterCommand('h2', {
                    title: 'Überschrift',
                    callback: function (cmd, val, params) {

                        if (isActive.apply(this, [cmd])) {
                            this.paragraphFormat.apply('N');
                            // this.format.remove('h2', { class: 'headline' });
                        }
                        else {
                            this.paragraphFormat.apply(cmd);
                            // this.paragraphStyle.apply('headline');
                        }

                    },

                    refresh: function ($btn) {
                        $btn.toggleClass('fr-active', isActive.apply(this, [$btn.data('cmd')]));
                    }

                });

            });

        },


        fetchData() {

          // siteNewsletter
          if(this.newsletter.siteNewsletter != null) {

            console.log("HIER");

            this.axios.get(this.$config.api + 'siteNewsletter/'+this.newsletter.siteNewsletter.id+'?include=siteNewsletter.newsletter,newsletter.banners,siteNewsletter.elements,siteNewsletterElement.products,siteNewsletterElementProduct.product&liteCatalogPageElement=1&filters[site]='+this.siteId+'&orderBy=siteNewsletterElement.sortorder')
                .then(res => {

                    res.data.elements.forEach(e => {

                        e.productSlots = [
                            e.products.find(p => p.sortorder == 0),
                            e.products.find(p => p.sortorder == 1),
                            e.products.find(p => p.sortorder == 2)
                        ];
                    })

                    console.log(res.data);
                    this.siteNewsletter = res.data;
                    this.isLoading = false;

                })

          // newsletter template
          } else {

            console.log("VORLAGE!");

            this.axios.get(this.$config.api + 'newsletter/'+this.newsletter.id+'?include=newsletter.banners,newsletter.elements&liteCatalogPageElement=1&orderBy=newsletterElement.sortorder')
                .then(res => {

                    this.siteNewsletter = {
                        newsletter: {
                            name: '',
                            channel: 12,
                            parent: this.newsletter.id,
                            site: this.siteId,
                            status: this.newsletterStatus.DRAFT,
                            scheduleDate: res.data.scheduleDate,
                            banners: res.data.banners,
                        },
                        subject: res.data.name,
                        salutation: null,
                        introText: null,
                        additionalText: null,
                        elements: res.data.elements,
                        site: this.siteId,
                        title: res.data.name,
                    };

                    this.siteNewsletter.elements.forEach(el => {

                        delete el.id;
                        delete el.newsletter;

                        el.products = [];
                        el.productSlots = [null, null, null];

                    })

                    // console.log("siteNewsletter: ", this.siteNewsletter);
                    this.isLoading = false;

                })


            }


        },


        addTextElement() {

            this.siteNewsletter.elements.push({
                catalogPageElement: null,
                sortorder: this.siteNewsletter.elements.length,
                content: '',
                products: [],
                productSlots: [null, null, null]
            })

            this.save();

        },

        newsletterSave() {

            this.save().then(res => {
              this.$notify.open({ content: 'Newsletter wurde gespeichert!', type: 'success' });
            })

        },


        newsletterSend() {

            this.modal.isLoading = true;

            this.modal.title = "Newsletter versenden";
            this.modal.class = 'newsletterSend vcenter';
            this.modal.type = 'newsletterSend';
            this.modal.width = '480';
            this.progressStatus = null;
            this.showModal = true;

            this.fetchRecipients()
                .then(res => {

                    if(res.data.length > 0) {

                        this.recipients = res.data;
                        this.modal.isLoading = false;

                    } else {

                        this.modal.type = "error";
                        this.modal.msg = "Sie haben noch keine Empfänger für den Versand angelegt! Bitte fügen Sie zuerst im Bereich \"Empfängerliste\" welche hinzu.";
                        this.modal.isLoading = false;

                    }

                })

        },

        newsletterSendTest() {

            this.progressStatus = null;
            this.modal.title = "Testnewsletter versenden";
            this.modal.class = 'newsletterSendTest vcenter';
            this.modal.type = 'newsletterSendTest';
            this.modal.width = '480';
            this.showModal = true;

        },

        newsletterSendOk() {

            this.showModal = true;
            this.isSending = true;


            this.progressStatus = null;
            this.modal.title = "Newsletter versenden";
            this.modal.class = 'newsletterSend vcenter';
            this.modal.type = 'progress';
            this.modal.width = '480';
            this.showModal = true;

            var self = this;

            this.save()
                .then(response => {

                    self.axios.get(self.$config.api + 'newsletter/send?siteNewsletter='+self.siteNewsletter.id)
                        .then((response) => {

                            let taskLogId = response.data.taskLogId;

                            self.refreshIntervalId = setInterval(function() {

                                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                    .then(function(response) {

                                        self.progressStatus = response.data;

                                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                            clearInterval(self.refreshIntervalId);

                                            if(response.data.status == 'Finished') {
                                                self.$notify.open({ content: 'Newsletter wurde erfolgreich versendet!', type: 'success'})
                                            }

                                            self.progressStatus = null;
                                            self.modal.isSaving = false;
                                            self.isSending = false;
                                            self.closeModal();

                                        }

                                    });

                            }.bind(self), 1000);

                        })

                })

        },

        newsletterSendTestOk() {

            if(!this.validateEmail(this.testRecipient)) {
                this.$notify.open({ content: 'Bitte geben Sie eine korrekte Email Adresse ein!', type: 'warning'});
                return false;
            }

            this.isSendingTest = true;
            this.modal.isSaving = true;

            var self = this;

            this.save().then(response => {

                self.axios.get(this.$config.api + 'newsletter/send?siteNewsletter='+this.siteNewsletter.id+'&testRecipient='+this.testRecipient)
                    .then(res => {

                        let taskLogId = res.data.taskLogId;

                        self.refreshIntervalId = setInterval(function() {

                            self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                .then(function(response) {

                                    self.progressStatus = response.data;

                                    if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                        clearInterval(self.refreshIntervalId);
                                        self.$notify.open({ content: 'Email wurde erfolgreich versendet!', type: 'success'})
                                        self.progressStatus = null;
                                        self.modal.isSaving = false;
                                        self.testRecipient = "";
                                        self.isSendingTest = false;

                                        self.closeModal();

                                    }

                                });

                        }.bind(self), 1000);

                    })

            })

        },




        save() {

            var self = this;

            if(this.siteNewsletter.title == "") {
                this.$notify.open( { content: 'Bitte geben Sie einen internen Namen für diesen Newsletter ein!', type: 'warning' })
                return;
            }

            this.isSaving = true;

            this.siteNewsletter.elements.forEach(el => {

                el.products = [];

                if(el.productSlots) {

                    el.productSlots.forEach(pSlot => {

                        if(typeof pSlot != 'undefined' && pSlot != null) {

                            el.products.push({
                                product: parseInt(pSlot.product.id),
                                sortorder: pSlot.sortorder,
                                showPrice: pSlot.showPrice
                            });
                        }

                    })

                }

            })

            let requestMethod = typeof this.siteNewsletter.id != 'undefined' ? 'put' : 'post';
            let url = 'siteNewsletter';


            if(typeof this.siteNewsletter.id != 'undefined') {

                requestMethod = 'put';
                url +=  '/'+this.siteNewsletter.id;

                // delete this.siteNewsletter.newsletter;
                /*
                this.siteNewsletter.newsletter = {
                    id: this.siteNewsletter.newsletter.id,
                    scheduleDate: this.siteNewsletter.newsletter.scheduleDate
                }
                */

            } else {

                requestMethod = 'post';

            }

            return this.axios[requestMethod](this.$config.api + url, this.siteNewsletter)
                .then(res => {

                    self.siteNewsletter.newsletter.id = res.data.newsletter;

                    if(typeof self.siteNewsletter.id == 'undefined') {
                        self.siteNewsletter.id = res.data.id;
                    }

                    this.axios.get(this.$config.api + 'siteNewsletter/'+self.siteNewsletter.id+'?include=siteNewsletter.newsletter,newsletter.banners,siteNewsletter.elements,siteNewsletterElement.products,siteNewsletterElementProduct.product&liteCatalogPageElement=1&filters[site]='+this.siteId+'&orderBy=siteNewsletterElement.sortorder')
                        .then(result => {

                            result.data.elements.forEach(e => {

                                e.productSlots = [
                                    e.products.find(p => p.sortorder == 0),
                                    e.products.find(p => p.sortorder == 1),
                                    e.products.find(p => p.sortorder == 2)
                                ];

                            })

                            this.siteNewsletter = result.data;
                            self.isSaving = false;
                            return result;

                        })

                })
                .catch(function(error) {
                    self.isSaving = false;
                    console.log("ERROR: ", error);
                });

        },

        onDragComplete(elements) {

            elements.forEach((element, index) => {
                element.sortorder = index;
            })

            this.isDragging = false;

            this.save();

        },

        newsletterAppendArticles() {

            this.modal.isSaving = true;

            this.save().then(res => {

                this._newsletterAppendArticles();

            })


        },

        _newsletterAppendArticles() {

            var self = this;

            let newRows = [];

            for (var i = this.siteNewsletter.elements.length - 1; i >= 0; --i) {

                let el = this.siteNewsletter.elements[i];

                if (el.catalogPageElement != null) {

                    let rIndex = this.markedRows.findIndex(_ => _ == el.catalogPageElement.id);

                    if(rIndex > -1) {
                        this.markedRows.splice(rIndex, 1);
                    } else {
                        this.siteNewsletter.elements.splice(i,1);
                    }

                }

            }


            // fetch all selected articles and push it into the elements array of the newsletter
            this.markedRows.forEach(rowId => {

                self.siteNewsletter.elements.push({
                    siteNewsletter: self.siteNewsletter.id,
                    content: null,
                    newsletter: self.siteNewsletter.id,
                    catalogPageElement: self.articles.data.find(article => article.id == rowId),
                    sortorder: self.siteNewsletter.elements.length,
                    products: [],
                    productSlots: [null, null, null]
                });

            })

            this.save()
                .then(() => {
                    this.closeModal();
                });

        },


        articleAppendProduct() {

            this.productSelected.sortorder = this.currentProductSlot;

            // fetch additional information for this product (price and offer property)
           this.axios.get(this.$config.api + 'pimProduct/'+this.productSelected.id)
              .then(res => {

                console.log("getting additional product data ...");
                // this.productSelected.price = res.data.price;
                // this.productSelected.offer = res.data.offer;
                this.$set(this.productSelected, "offer", res.data.offer);
                this.$set(this.productSelected, "price", res.data.price);


                  let el = this.siteNewsletter.elements[this.currentElementIndex];
                  el.productSlots[this.currentProductSlot] = {
                      voucherImageUrl: this.productSelected.voucherImageUrl,
                      product: this.productSelected,
                      sortorder: this.currentProductSlot,
                      showPrice: true,
                  }

                  this.$forceUpdate();
                  this.closeModal();


                  // this.$nextTick(() => this.$forceUpdate() );

              })


        },


        newsletterElementRemove(articleIndex) {

            this.siteNewsletter.elements.splice(articleIndex, 1);

            this.save().then(res => {
                this.$notify.open( { content: 'Beitrag wurde erfolgreich entfernt!', type: 'success'});
            })

        },

        getExcerpt(el, maxLength=550) {

            let str = "";

            if(typeof el.content != "undefined") {

                let text = el.content;

                if(text.length > maxLength) {
                    text = text.substr(0, maxLength);
                    str = text.substr(0, Math.min(text.length, text.lastIndexOf(" "))) + ' ...'
                } else {
                    str = text;
                }

                return str + ' <a class="readmore" href="http://www.apothekenkatalog.at/'+el.friendlyName+'" target="_blank">weiterlesen</a>';

            } else {

                return "";

            }

        },

        productDelete(element, index) {

            element.productSlots[index] = null;
            this.$forceUpdate();

        },

        productAdd(articleIndex, productIndex, showDefaultProducts=true) {

            this.modal.title = "Produktplacements hinzufügen";
            this.modal.type = "articleProducts";
            this.modal.class = 'addProduct vcenter';

            this.modal.width = '640';

            this.showModal = true;
            this.modal.isLoading = true;

            // this.currentElement = article;
            this.currentElementIndex = articleIndex;
            this.currentProductSlot = productIndex;

            this.showDefaultProducts = showDefaultProducts;

            if(showDefaultProducts) {

                // this.getDefaultProducts(article.catalogPageElement.id).then(res => {
                this.getDefaultProducts(this.siteNewsletter.elements[articleIndex].catalogPageElement.id).then(res => {
                    this.defaultProducts = res;
                    this.modal.isLoading = false;
                })

            } else {

                this.defaultProducts = null;
                this.modal.isLoading = false;

            }

        },


        closeModal() {

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            this.testRecipient = "";
            this.isSendingTest = false;
            this.progressStatus = null;

            this.modal.isSaving = false;
            this.showModal = false;
            this.markedRows = [];
            this.productSelected = null;
            this.showDefaultProducts = false;

        },

        getDefaultProducts(pageElementId) {

            return this.axios.get(this.$config.api + 'catalogPageElement/'+pageElementId+'/products')
                .then(res => res.data)

        },

        asyncGetProducts(query) {

            if(query.length > 2) {

		          this.isAsyncFetchingData = true;

	            this.axios.get(this.$config.api + 'pimProduct/search?q='+query+'&includeVoucherImageUrl=1')
	                .then(response => {

	                    this.asyncFetchedProducts = response.data;
	                    this.isAsyncFetchingData = false;

	                });

	        }

        },

        openNewsletterArticles() {

            this.modal.title = "Artikel";
            this.modal.type = "newsletterArticles";
            this.modal.class = 'newsletterArticles vcenter';
            this.modal.width = '860';
            this.modal.isLoading = true;
            this.showModal = true;

            var self = this;

            if(typeof this.siteNewsletter.elements != 'undefined') {
                this.siteNewsletter.elements.forEach(function(article) {
                    if(article.catalogPageElement != null) {
                        self.markedRows.push(article.catalogPageElement.id.toString());
                    }
                })
            }

            this.axios.get(this.$config.api + 'catalogPageElement/onlineCatalogArticles?includeContent=1')
                .then(res => {

                    this.articles.data =  res.data;
                    this.modal.isLoading = false;

                    Event.$on('vue-tables.tblNewsletterArticles.row-click', function(data) {

                        if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                            return false;
                        }

                        let foundIndex = self.markedRows.findIndex(row => row == data.row.id);

                        if(foundIndex > -1) {
                            self.markedRows.splice(foundIndex, 1);
                        } else {
                            self.markedRows.push(data.row.id);
                        }

                    });


            });

        },

    }


}



</script>

<style>

    .flip-list-move {
        transition: transform 0.2s;
    }

    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

</style>



<style>

    .flip-list-move {
        transition: transform 0.2s;
    }

    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

</style>

<style lang="scss">

    .centered {
        max-width: 700px;
        margin: 0 auto;

        .control > .control {
            max-width: 100%;
        }
    }

    .banners {

		.banner {
			position: relative;
            background-position: 50% 50%;
			background-repeat: no-repeat;
			background-size: contain;
			width: 100%;
			height: 210px;
			margin-bottom: 10px;

            &[lazy=loading] {
                background-size: 20% !important;
            }
            &[lazy=error] {
                background-size: contain !important;
            }

			&::before {
			  content: "";
			  position: absolute;
			  z-index: 2;
			  top: 0;
			  left: 0;
			  width: 100%;
			  height: 100%;
			  background-color: rgba(255,255,255,0.7);
			}

			&.is-active {
				&::before {
					background-color: transparent;
				}
			}

			.checkbox {
				position: absolute;
				z-index: 10;
				right: 0;
				top: 0;
				width: 32px;
				height: 32px;
				background-color: #FFF;
				display: flex;
				align-items: center;
				justify-content: center;
                .pretty {
                    margin-right: 0;
                }
			}
		}

		&:last-child {
			margin-bottom: 0;
		}

	}

    /* modal */
    .modal {

        &.addProduct {
            .modal-card {
                min-height: 250px;
            }
            .modal-card-body {
                overflow: visible !important;
            }
        }

        .modal-card {

            min-height: 640px;
            max-height: 640px;

            .modal-card-body {
                overflow-y: auto;
            }
        }

        /* table articles in modal */
        .tblNewsletterArticles {

            th {

                &:first-child {
                    width: 40px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 4px;
                }
                &:nth-child(2) {
                    width: 70px;
                }

            }

            td {
                padding: 5px 8px;

                &:first-child {
                    position: relative;
                    width: 35px;
                }

                &:first-child .checkboxWrapper {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    left: 0; right: 0;
                    top: 0;
                    bottom: 0;
                    padding-left: 4px;
                }

                &:nth-child(2) .imgWrapper {
                    background-repeat: no-repeat;
                    background-position: 50% 50% !important;
                    background-size: cover;
                    width: 70px;
                    height: 50px;
                    margin: 0;
                    background-color: #FFF;
                    border: 1px solid #efefef;
                    border-radius: 2px;
                }
                &:nth-child(2) .imgWrapper[lazy=loading] {
                    background-size: 30% !important;
                }
                &:nth-child(2) .imgWrapper[lazy=error] {
                    background-size: contain !important;
                }


            }




        }
    }



    .tbl-newsletter >>> th:first-child {
        width: 35px;
    }




    .newsletterArticles {

        margin: 0 auto;
        width: 100%;

        .newsletterArticle {
            max-width: 100%;
            margin:0 0 12px 0;
            padding: 10px;
            white-space: normal;
            background: #f8f8f8;
            border-radius: 3px;

            .column {

                padding: 10px 5px;
                line-height: 1.2rem;

                .headline {
                    display: block;
                    margin-top: 5px;
                    margin-bottom: 10px;
                    font-size: 1.2rem;
                }

                &:first-child {
                    padding-left: 0;
                }
                &:last-child {
                    padding-right: 0;
                }

                .preview {
                    a.readmore {
                        background: none !important;
                        display: inline !important;
                        text-decoration: underline !important;
                        font-weight: normal !important;
                        border: none !important;
                        text-transform: lowercase !important;
                    }
                }


                img.lazy {
                    width: 250px;
                    height: auto;
                    border: 1px solid #efefef;
                    margin: 0;
                    background-image: none !important;

                    &[lazy=loading] {
                        background-image: none !important;
                        width: 50px !important;
                        height: 50px !important;
                        margin: 0 auto !important;
                    }


                }



                &.appendedProducts {

                    padding: 0;
                    margin: 25px 0 15px 0;

                    .title {
                        margin-bottom: 8px;
                        font-size: 12px;
                        text-transform: uppercase;
                    }

                    .appendedProductsWrapper {

                        width: 90%;
                        margin: 0 auto;
                        display: flex;
                        justify-content: space-between;

                        .productCol {

                            width: 32.5%;

                            .product {
                                position: relative;
                                /*width: 32.5%;*/
                                width: 100%;
                                height: 130px;
                                border: 1px dashed #ddd;
                                border-radius: 3px;
                                transition: all .3s ease;

                                display: flex;
                                justify-content: center;
                                align-items: center;
                                overflow: hidden;

                                &.filled {

                                    position: relative;
                                    border: 1px solid #ddd;
                                    /*padding: 10px;*/
                                    background-color: #FEFEFE !important;
                                    display: block;

                                    .flash {
                                      position: absolute;
                                      z-index: 9;
                                      left: 4px;
                                      top: 4px;
                                      position: absolute;
                                      background-color: #68b150;
                                      width: 32px;
                                      height: 32px;
                                      border-radius: 50%;
                                      font-size: 8.5px;
                                      line-height: 32px;
                                      text-align: center;
                                      color: #FFF;
                                    }
                                    .content {
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        padding: 5px;
                                        height: calc(100% - 24px);

                                        .productImage {
                                            max-width: 70px;
                                            max-height: 100%;
                                            width: 100%;
                                            height: auto;
                                            float: left;
                                            margin-right: 5px;
                                        }
                                        .productTitle {
                                            font-size: 11px;
                                            line-height: 12px;
                                        }
                                        .productPrice {
                                          font-size: 11px;
                                          margin-top: 2px;
                                          s {
                                            color: #AAA;
                                          }
                                        }

                                    }

                                    .showPriceSwitcher {
                                        position: absolute;
                                        background-color: #f5f5f5;
                                        padding: 3px 0;
                                        border-top: 1px solid #f0f0f0;
                                        bottom: 0;
                                        left: 0;
                                        right: 0;
                                        margin: 0 auto;
                                        text-align: center;
                                        font-size: 10px;
                                    }

                                    .deleteProduct {
                                        position: absolute;
                                        right: 5px;
                                        top: 5px;

                                        .icon {
                                            height: 14px;
                                            width: 14px;
                                            line-height: 14px;
                                            margin: 0;
                                            i {
                                                transition: color .3s ease;
                                                font-size: 14px;
                                                color: #ddd;
                                            }

                                            &:hover {
                                                i {
                                                    color: #666;
                                                }
                                            }
                                        }
                                    }
                                }

                                .icon {
                                    height: 32px;
                                    width: 32px;
                                    line-height: 32px;
                                    i {
                                        transition: color .3s ease;
                                        font-size: 32px;
                                        color: #ddd;
                                    }
                                }

                                &:hover {
                                    border-color: #888;

                                    .icon i {
                                        color: #888;
                                    }

                                }

                            }

                            .productVoucher {
                                margin-top: 5px;
                            }
                        }

                    }

                }



                &.actions {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .icon {
                        padding: 3px;
                        margin: 0;
                        background: #eaeaea;
                        border-radius: 3px;
                        width: 24px;
                        height: 24px;
                        line-height: 24px;
                        color: #aaa;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: color .3s ease;

                        i {
                            line-height: inherit;
                        }

                        &:first-child {
                            margin-bottom: 5px;
                        }
                        .delArticle {

                            visibility: hidden;
                            opacity:0;
                            transition: opacity 0.5s ease;

                            &:not(.is-disabled) {
                                visibility: visible;
                                opacity:1;
                            }

                        }

                        &:hover {
                            color: #222;
                        }

                    }


                }
            }


            .imgWrapper {
                width: 200px;
                height: 130px;
                margin: 0 5px 0 0;
                background-color: #FFF;
                border: 1px solid #efefef;
                border-radius: 2px;
            }


        }



    }


    .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 85px;
		height: 65px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;

        &[lazy=loading]  {
    		background-size: 30% !important;
    	}
        &[lazy=error]  {
    		background-size: contain !important;
    	}

        &.plain {
            background: none;
            display: flex;
            justify-content: center;
            align-items: center;

            .icon {
                height: 32px;
                width: 32px;
                line-height: 32px;
                i {
                    transition: color .3s ease;
                    font-size: 32px;
                    color: #aaa;
                }
            }

            &:hover {

                .icon i {
                    color: #222;
                }

            }
        }
	}

    .hrLine {
        padding-top: 12px;
        border-bottom: 1px solid #EEE;
        margin: 0 -20px 12px -20px;
    }

    .defaultProducts {

        display: flex;
        justify-content: flex-start;
        margin-bottom: 25px;

        .defaultProduct {

            background-color: #FFF;
            background-repeat: no-repeat;
            background-position: 50% 50% !important;
            background-size: contain;
            width: 130px;
            height: 85px;

            border: 1px solid #eee;
            border-radius: 3px;

            padding: 0;
            margin: 0 5px 0 0;

            transition: all .3s ease;
            cursor: pointer;

            &:last-child {
                margin-right: 0;
            }

            &.is-selected {
                border-color: red;
            }

            &[lazy=loading] {
                background-size: 30% !important;
            }
            &[lazy=error] {
                background-size: contain !important;
            }
        }
    }

    .multiselect__option,
    .multiselect__single {

        display: flex;
        align-items: center;

        .option__image {

            width: 25px;
            height: 25px;
            max-height: 25px;
            float: left;
            margin-right: 5px;

            img {
                width: 90%;
                height: 90%;
                object-fit: contain;
            }
        }

    }

    .multiselect__spinner {
        height: 20px;
        width: 20px;
        top: 8px;
        right: 20px;
    }

    .newsletterActions {

        margin: 25px 0;

        .button {

            &:not(:last-child) {
                margin-right: 10px;
            }
        }

    }

    .newsletterSend,
    .newsletterSendTest {

        &.modal {
            .modal-card {
                min-height: 50px;
            }
        }

    }


    .froalaRTE {

        .fr-view {
            white-space: normal;
            line-height: 1.25rem;
            padding: 16px 10px !important;

            color: rgb(68, 68, 68);

            img {
                .fr-dii.fr-fil {
                    margin: 5px 10px 5px 0;
                    max-width: calc(100% - 10px);
                }
                .fr-dii.fr-fir {
                    margin: 5px 0 5px 10px;
                    max-width: calc(100% - 10px);
                }
            }
            h2 {
                margin-top: 5px;
                margin-bottom: 10px;
                font-size: 1.2rem;
                font-weight: 700;
            }

            a {
                display: inline;
                background: none;
                padding: 0;
                margin: 0;
                border: none;
                color: inherit;
            }
        }



    }

    .sortable-chosen {
        .control {
            pointer-events: none;
        }
    }

    .fr-popup {

        .fr-buttons {

            button[id^=imageManager] {
                display: none !important;
            }
        }
    }

    .sectionButtons {
        margin-top: 25px;
        display: flex;
        justify-content: center;
        button:not(:last-child) {
            margin-right: 5px;
        }
    }

    .rteInfo {
        padding: 12px;
        font-size: 11px;
        color: #888;
        background-color: #f1f1f1;
        white-space: normal;
        line-height: 1.1rem;

        .icon {
            font-size: 12px;
            margin: 0 3px 0 0 !important;;
            width: 16px;
            height: 16px;
            padding: 0;
        }
    }

    .productSelectTitle {
        text-transform: uppercase;
        font-size: 12px;
        color: #888;
        margin-bottom: 8px;
    }
</style>
